import { Exercise } from '../exercise';
import { Factory } from '@infodata-group/inf-commons';
import dayjs from 'dayjs';
import { PeriodFactory } from './period-factory';

export class ExerciseFactory implements Factory<Exercise> {
  build(o: any): Exercise {
    const exercise = new Exercise();
    exercise.code = o.Code;
    exercise.currency = o.Currency;
    exercise.currencyManagement = o.CurrencyManagement;
    exercise.dateStart = dayjs(o.DateBegin, 'DD.MM.YYYY').toDate();
    exercise.dateEnd = dayjs(o.DateEnd, 'DD.MM.YYYY').toDate();
    exercise.exerciseClosure = o.ExerciceClosure;
    exercise.exerciseClosureRem = o.ExerciceClosureRem;
    const periodFactory = new PeriodFactory();
    for (const p of o.Periods) {
      exercise.periods.push(periodFactory.build(p));
    }
    return exercise;
  }

  getApi(): string {
    return '';
  }
}
